import { forwardRef, ReactNode, Ref } from 'react';
import classNames from 'classnames';

import { FieldState } from 'components/Form/types';

type TrailingAddOnProps = {
  trailingAddOn?: ReactNode;
  state?: FieldState;
  show: boolean;
  disablePointerEvents?: boolean;
};

export const TrailingAddOn = forwardRef(
  (
    { trailingAddOn, state = 'default', show, disablePointerEvents = true }: TrailingAddOnProps,
    ref: Ref<HTMLDivElement>,
  ) => {
    return (
      <div
        ref={ref}
        className={classNames(show ? 'absolute inset-y-0 right-0 flex items-center pr-3' : 'size-0', {
          'pointer-events-none': disablePointerEvents,
        })}
      >
        {show && trailingAddOn ? (
          <span
            className={classNames(
              {
                'text-gray-500': state === 'default',
                'text-blue-500': state === 'pending-validation',
              },
              'group-focus-within:text-gray-500 sm:text-sm h-full flex items-center',
            )}
          >
            {trailingAddOn}
          </span>
        ) : null}
      </div>
    );
  },
);

TrailingAddOn.displayName = 'TrailingAddOn';
